class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".back-to-top-button__btn");
    this.scrollThreshold = parseInt(this.dataset.scrollThreshold) || 300;
    this.isVisible = false;
    this.throttleTimeout = null;

    this.handleScroll = this.throttle(this.handleScroll.bind(this), 16);
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.button.addEventListener("click", this.handleClick);
    window.addEventListener("scroll", this.handleScroll, { passive: true });

    // Check initial scroll position
    this.handleScroll();
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.handleClick);
    window.removeEventListener("scroll", this.handleScroll);

    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout);
    }
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.scrollThreshold && !this.isVisible) {
      this.show();
    } else if (scrollTop <= this.scrollThreshold && this.isVisible) {
      this.hide();
    }
  }

  handleClick(event) {
    event.preventDefault();
    this.scrollToTop();
  }

  show() {
    this.classList.add("visible");
    this.isVisible = true;
  }

  hide() {
    this.classList.remove("visible");
    this.isVisible = false;
  }

  scrollToTop() {
    const startPosition = window.pageYOffset;
    const startTime = performance.now();
    const duration = 800; // milliseconds

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }

    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easeInOutCubic(progress);

      window.scrollTo(0, startPosition * (1 - ease));

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }

    requestAnimationFrame(animateScroll);
  }

  throttle(func, limit) {
    return function () {
      const args = arguments;
      const context = this;

      if (!this.throttleTimeout) {
        this.throttleTimeout = setTimeout(() => {
          func.apply(context, args);
          this.throttleTimeout = null;
        }, limit);
      }
    };
  }
}

// Register the custom element
if (!customElements.get("back-to-top-button")) {
  customElements.define("back-to-top-button", BackToTopButton);
}
